import { render } from "./ModificacionDetalle.vue?vue&type=template&id=a8597708"
import script from "./ModificacionDetalle.vue?vue&type=script&lang=js"
export * from "./ModificacionDetalle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__